import { useEffect } from 'react';

const SUFFIX = 'Clevor';

/**
 * Sets document.title for the duration of a page. Every tab previously read
 * "Clevor — The Execution Layer for GovCon", which is useless once you have
 * six of them open, and costs SEO on the public pages.
 *
 * Pass null to leave the title alone (e.g. while data is still loading and
 * the real title isn't known yet).
 */
export function usePageTitle(title: string | null) {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `${title} · ${SUFFIX}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}

export default usePageTitle;
